import { selectChangeMessageForHtmlString } from '@newStore/documentUI/changeMessageSelectors/selectChangeMessageForHtmlString';
import { type EditAsideDescription, RequiredType } from '@nodeTypeConfig/configTypes';

export const descriptionComponent: EditAsideDescription = {
  component: 'description',
  reactComponent: 'AsideDescription',
  property: 'description',
  label: 'Omschrijving',
  asideChangeMessageSelector: selectChangeMessageForHtmlString,
};

export const llinkidDescriptionComponent: EditAsideDescription = {
  ...descriptionComponent,
  required: RequiredType.ERROR,
  options: {
    showMarkerButton: true,
  },
};

export const shortDescriptionComponent: EditAsideDescription = {
  ...descriptionComponent,
  property: 'shortdescription',
  label: 'Tegeltekst',
};

export const introDescriptionComponent: EditAsideDescription = {
  ...descriptionComponent,
  label: 'Inleiding',
  fullLabel: 'Inleiding (Belangrijk: De zoeker toont de inleiding in de zoekresultaten)',
  required: RequiredType.WARNING,
};
